import moment from 'moment'

const INIT = 0
const NUM_OF_HOURS = 24
const TODAY = 'Today'

const formattedHourToCalendar = (hour) => {
  const formattedHours = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00'
  ]

  return formattedHours[hour]
}

const getDayAtZeroHours = (date, utcTimezoneNumber) => {
  return date
    .utcOffset(utcTimezoneNumber || 0)
    .set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    })
    .clone()
}

const getWeekDays = (date, daysOfDiff = 6, timezone) => {
  const selectedStore = JSON.parse(localStorage.getItem('selectedStore'))
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const utcTimezoneNumber = moment()
    .tz(timezone || selectedStore?.timeZone || userInfo?.user?.client?.timeZone)
    .format('Z')
  const utcTimezoneNumberFormated = utcTimezoneNumber.replace('+', '').replace(':00', '')
  const utcDate = getDayAtZeroHours(date, utcTimezoneNumberFormated)
  const today = moment()
    .tz(timezone || selectedStore?.timeZone || userInfo?.user?.client?.timeZone)
    .format('DDD')
  const days = []
  for (let ix = 0; ix <= daysOfDiff; ix++) {
    const day = ix === 0 ? utcDate : utcDate.add(1, 'days')
    const dayName = String(today) === day.format('DDD') ? 'Today' : day.format('ddd')
    days.push({
      day: day.format('D'),
      name: dayName,
      date: day.format(),
      today: TODAY === dayName,
      active: parseInt(day.format('x')) >= parseInt(getDayAtZeroHours(moment(), +utcTimezoneNumberFormated).format('x'))
    })
  }
  return days
}

const getCurrentHour = (_) => {
  let date = new Date()
  return date.getHours()
}

const getHours = (storeTimeZone) => {
  let currentHour = null

  if (storeTimeZone) {
    currentHour = moment().tz(storeTimeZone).format('HH')
  } else {
    currentHour = new Date().getHours()
  }

  let hours = []
  for (let ix = 0; ix < NUM_OF_HOURS; ix++) {
    const hour = INIT + ix
    hours.push({
      text: `${hour >= 10 ? (hour === 24 ? '00' : hour) : '0' + hour}:00`,
      value: hour === 24 ? 0 : hour,
      active: hour >= currentHour
    })
  }
  return hours
}

const satToColor = (realSta, optimalSaturation) => {
  const { floor } = Math
  const UNCERTAINTY = 0.25
  const INTERVAL_WIDTH = (optimalSaturation - UNCERTAINTY / 2) / 5
  if (realSta === Infinity) return `linear-gradient(145.58deg, #F5222D -4.83%, #FFA2DF 107.91%);`
  if ((optimalSaturation - UNCERTAINTY < realSta && realSta < optimalSaturation + UNCERTAINTY) || realSta === 0) {
    return '#E8E8E8'
  } else {
    if (realSta < optimalSaturation - UNCERTAINTY) {
      const intervalNum = floor((optimalSaturation - UNCERTAINTY - realSta) / INTERVAL_WIDTH) + 1
      const opacity = 0.2 * intervalNum
      return `rgba(250, 213, 20, ${opacity})`
    }
    if (optimalSaturation + UNCERTAINTY < realSta) {
      const intervalNum = floor((realSta - optimalSaturation + UNCERTAINTY) / INTERVAL_WIDTH) + 1
      const opacity = 0.2 * intervalNum
      return `rgba(245, 34, 45, ${opacity})`
    }
  }
}

const getIds = (array) => {
  let ids = []
  array.forEach((element) => {
    ids.push(element.id)
  })
  return ids
}

const mapQuotas = (quotas, resource) => {
  return quotas.map(({ quota: { from, to } }) => {
    const mappedQuota = {
      from,
      to
    }
    if (resource) mappedQuota.resource_id = resource
    return mappedQuota
  })
}

const createQuotas = (resourcesIds, quotas) => {
  let mappedQuotas = []
  if (resourcesIds.length > 0) {
    resourcesIds.forEach((resource) => {
      mappedQuotas = [...mappedQuotas, ...mapQuotas(quotas, resource)]
    })
  } else {
    mappedQuotas = [...mappedQuotas, ...mapQuotas(quotas)]
  }
  return mappedQuotas
}

const splitAnArray = (array, eachNum) => {
  return array.reduce((all, one, i) => {
    const ch = Math.floor(i / eachNum)
    all[ch] = [].concat(all[ch] || [], one)
    return all
  }, [])
}

const getContextsByTimeZone = (contexts, timezone) => {
  let formattedContexts = {}
  contexts.forEach((context) => {
    const { from } = context
    const dateWithTz = moment(from).tz(timezone)
    const day = dateWithTz.date()
    if (!formattedContexts[day]) {
      formattedContexts[day] = {}
    }
    formattedContexts[day][dateWithTz.hour()] = {
      context
    }
  })
  return formattedContexts
}

const reverseCoordinates = (geoGeoJson) => {
  const newGeoJson = JSON.parse(JSON.stringify(geoGeoJson))
  const { coordinates } = newGeoJson
  newGeoJson.coordinates[0] = coordinates[0].map((coors) => coors.reverse())
  return newGeoJson
}

const getDefaultDate = (_) => moment().startOf('week')

const standardDate = (date) => {
  if (date && typeof date === 'object') {
    return date.toDate()
  }
  return date
}

export {
  getWeekDays,
  getHours,
  getCurrentHour,
  satToColor,
  getDayAtZeroHours,
  getIds,
  createQuotas,
  splitAnArray,
  reverseCoordinates,
  getDefaultDate,
  standardDate,
  formattedHourToCalendar,
  getContextsByTimeZone
}
